module.exports = __webpack_public_path__ + "media/images/icon_2-2f9b455501f4ec04829cb942a308afb2.svg";